<div class="content-body">
  <ng-content></ng-content>
</div>



